// 5x5 grid, 25 cells. Cell at index 12 (0-based) = position 13 (1-based) is the lead orb.
// The 24 surrounding cells reference stack.cells[n] where n is the sequential label index (0-23).
// Lead orb is inserted at position 12 (0-based) in the rendered grid.

const LEAD_INDEX = 12; // 0-based position in the 5×5 grid

// 24 surrounding tech labels (indices 0-23 map to stack.cells[0..23] in locale JSON)
const stackLabelIndices = Array.from({ length: 24 }, (_, i) => i);

const stack = {
  gridSize: 5,
  leadIndex: LEAD_INDEX,
  cells: stackLabelIndices,
};

export default stack;
